module.exports = __webpack_public_path__ + "img/inflatablePinkContact.eb7e850a.svg";